import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useAuth } from '../auth/AuthContext.tsx';
import { firstAllowedRoute, ROUTES } from '../routing/routes.ts';

export function NotFoundPage(): React.JSX.Element {
  const navigate = useNavigate();
  const { isAuthenticated, state } = useAuth();
  const home = isAuthenticated ? firstAllowedRoute(state.permissions) : ROUTES.login;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        color: 'text.primary',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      <Typography variant="h2" sx={{ fontWeight: 800 }}>
        404
      </Typography>
      <Typography variant="h6" sx={{ opacity: 0.85 }}>
        This page isn't available.
      </Typography>
      <Button onClick={() => navigate(home, { replace: true })}>
        Go back
      </Button>
    </Box>
  );
}

export default NotFoundPage;
